<app-privacy-policy></app-privacy-policy>
<app-bottom-menu></app-bottom-menu>